import { render } from "./AlertList.vue?vue&type=template&id=3667d5a6&scoped=true"
import script from "./AlertList.vue?vue&type=script&lang=js"
export * from "./AlertList.vue?vue&type=script&lang=js"

import "./AlertList.vue?vue&type=style&index=0&id=3667d5a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3667d5a6"

export default script